export default "__VITE_ASSET__CkoXiUdm__"